import _ from "lodash";
import generateUniqueIds from "./generateUniqueId";
import {
  handleRecoResultAPI,
  handleCreateUserAPI,
  updateUserRecoId,
} from "../services/recommendationService";
import { handleMetaRecoResultAPI } from "../services/adminToolServices/getMetaRecommendation";

/**
 * Extend defaults object array handling for local storage
 *
 * */

Storage.prototype.setObj = function (key: any, obj: Object) {
  return this.setItem(key, JSON.stringify(obj));
};
Storage.prototype.getObj = function (key: any) {
  let key1: any = key ? this.getItem(key) : "";
  return (key1 !== "undefined" || key1 !== "null") && JSON.parse(key1);
};

/**
 * Used to set response to local storage
 * @param respData
 */
const setUserResponse = (respData: any) => {
  // TODO: for clearing data
  // localStorage.removeItem("reco-data");
  // localStorage.removeItem("user-response");
  let userDataObj: any = {};
  userDataObj.contentTypeId = respData.contentTypeId;
  userDataObj.recoId = respData.recoId;
  userDataObj.recoValues = respData.recoValues;
  userDataObj.values = respData.values;
  addUpdateResponseData(userDataObj);
};

/**
 * Used to Insert new data and replace if duplicate
 * @param newObject
 */
const addUpdateResponseData = (newObject: any) => {
  let storeUserResponse: any = [];
  if (localStorage.getObj("user-response")) {
    storeUserResponse = localStorage.getObj("user-response");
    const index = storeUserResponse.findIndex(
      (id: any) => id.contentTypeId === newObject.contentTypeId
    );
    if (index === -1) {
      storeUserResponse.push(newObject);
    } else {
      storeUserResponse[index] = newObject;
    }
  } else {
    storeUserResponse.push(newObject);
  }
  localStorage.setObj("user-response", storeUserResponse);
};

/**
 * Used to make data ( data massaging ) for reco engine format
 * @param userData - local storage user response data
 */
const createRecoData = async (userData: any) => {
  const surveyType = localStorage.getItem("surveyType");
  let recoData: any = {};
  let recoInputData: any = {};
  _.map(userData, function (respData: any) {
    // reco ID array storage
    if (Array.isArray(respData.recoId)) {
      _.map(respData.recoId, (recoIds, index) => {
        const key: any = recoIds;
        recoData[key] = isNaN(respData.recoValues[index])
          ? respData.recoValues[index]
          : _.isNull(respData.recoValues[index]) ||
            respData.recoValues[index] === true
          ? respData.recoValues[index]
          : Number(respData.recoValues[index]);
      });
    } else if (respData?.recoId?.toLowerCase() === "needstaterank") {
      // reco ID ranking storage
      let rankObj: any = {};
      if (localStorage.getItem("surveyType") === "fullSurvey") {
        respData.recoValues.push("everyday-health");
      }
      _.map(respData.recoValues, (rankData, index) => {
        let keySuffix = index + 1;
        const key: any = "r" + keySuffix;
        rankObj[key] = isNaN(rankData)
          ? rankData
          : _.isNull(rankData) || rankData === true
          ? rankData
          : Number(rankData);
      });
      recoData["NeedstateRank"] = rankObj;
    } else {
      const key: any = respData.recoId;
      recoData[key] = isNaN(respData.recoValues)
        ? respData.recoValues
        : _.isNull(respData.recoValues) || respData.recoValues === true
        ? respData.recoValues
        : Number(respData.recoValues);
    }
  });

  recoData["short_survey"] = surveyType === "fullSurvey" ? 0 : 1;

  recoInputData["recoUserId"] = localStorage.getObj("reco-user-id");
  recoInputData["createdAt"] = +new Date();
  recoInputData["recoKeys"] = JSON.stringify(recoData);
  recoInputData["surveyData"] = JSON.stringify(userData);
  return await handleRecoResultAPI(recoInputData);

  /*Testing for meta-reco API*/
  // recoInputData = JSON.stringify(recoData);
  // return await handleMetaRecoResultAPI(recoInputData);
};

/**
 * Used to fetch reco data from latest stored in user data
 * Executes at the end of Survey
 * @param foundationalList
 */

const filterRecoResponseData = async (foundationalList: Array<String>) => {
  generateSurveyId();
  const questionContentTypeIdList = foundationalList;
  let userData = localStorage.getObj("user-response");
  let newUserDataArray: any = [];
  _.map(userData, function (eachUserData) {
    if (questionContentTypeIdList.includes(eachUserData.contentTypeId)) {
      newUserDataArray.push(eachUserData);
    }
  });
  localStorage.setObj("user-response", newUserDataArray);
  let recoData: any = localStorage.getObj("user-response");
  return await createRecoData(recoData);
};

/**
 * Used to  handle user info and send it through API call
 */
export const handleUserInfo = async (userDataInfo: any) => {
  const handleCreateUserAPIResult: any = await handleCreateUserAPI(
    userDataInfo
  ).then(async (res: any) => {
    let recoIdData: any = {
      createdAt: localStorage.getObj("reco-result")?.createdResultAt,
      currentRecoUserId: res?.data?.createUser?.recoUserId,
      sessionRecoUserId: localStorage?.getObj("reco-user-id"),
    };

    if (
      localStorage.getObj("reco-result") &&
      recoIdData?.currentRecoUserId !== recoIdData?.sessionRecoUserId
    ) {
      const updateUserRecoIdResult: any = await updateUserRecoId(
        recoIdData
      ).then((resp: any) => {
        if (resp?.data?.updateRecoUserId?.status === 200) {
          return resp;
        }
      });
      return updateUserRecoIdResult;
    } else if (
      recoIdData?.currentRecoUserId !== recoIdData?.sessionRecoUserId
    ) {
      localStorage.setObj("reco-user-id", res?.data?.createUser?.recoUserId);
      let userInfo = localStorage.getObj("user-info");
      userInfo.recoUserId = res?.data?.createUser?.recoUserId;
      localStorage.setObj("user-info", userInfo);
      return res;
    }
    return res;
  });
  return handleCreateUserAPIResult;
};

/**
 * Used to  update user info
 */
const updateUserInfo = async (updateData: any) => {
  let recoIdData: any = {
    createdAt: localStorage.getObj("reco-result")?.createdResultAt,
    currentRecoUserId: updateData?.data?.createUser?.recoUserId,
    sessionRecoUserId: localStorage?.getObj("reco-user-id"),
  };
  if (recoIdData.currentRecoUserId !== recoIdData.sessionRecoUserId) {
    const updateUserRecoIdResult: any = await updateUserRecoId(recoIdData).then(
      (res: any) => {
        if (res?.status === 200) {
          return res;
        }
      }
    );
    return updateUserRecoIdResult;
  } else {
    return updateData?.data?.updateRecoUserId?.status;
  }
};

/**
 * Used to generate unique ID and store
 */
export const generateSurveyId = () => {
  if (!localStorage.getObj("reco-user-id")) {
    const id: any = generateUniqueIds();
    localStorage.setObj("reco-user-id", id);
  }
};

const getPreFillDataByContentKey = (contentTypeId: any) => {
  let getRecoValuesById: any = {};
  if (localStorage.getObj("user-response")) {
    let getRecoData: any = localStorage.getObj("user-response");
    getRecoValuesById = _.find(getRecoData, function (eachObj: any) {
      return eachObj.contentTypeId === contentTypeId;
    });
  }
  return getRecoValuesById;
};
export { setUserResponse, filterRecoResponseData, getPreFillDataByContentKey };

// {"operationName":"getRecommendation","variables":{"answers":{"recoUserId":"0r2ja6095ai6gh9ev5199qwsms3z5pr7","createdAt":1631169041165,
// "recoKeys":
// "{"Name":"Siddhi","Reason":["my-best-self","feel-great"],"NeedstateRank":{"r1":"stress-mood","r2":"immunity","r3":"energy","r4":"everyday-health"},"WellnessActivities":["supplements","meal-replacements"],"WellnessBarriers":["knowledge","budget"],"StressIntensity":2,"StressChallenges":["work"],"WeeklyGoodSleep":5,"FallAsleepTime":30,"SleepQuality":2,"WakeUpRefreshed":5,"ImmunityPriority":"episodic-immunity","EnergyNeeds":"energy-burst","FitnessCadence":0,"Gender":"Female","Age":24,"SunExposure":"low","Smoking":0,"DietRestrictions":["UHJvZ3JhbTowNmFlMGQ4YS03MTE1LTQxYjgtOTlhZi0wZDgzYjVmNTI5MDg=","UHJvZ3JhbTo3YTRhYmYxNi1lZDY3LTQxMDItYTMwYi0wMmJjZjUzMmZkNzc=","UHJvZ3JhbTo1YjQyYTc5Yi0wY2M4LTQyZTYtOGM4Zi05YjIxM2JmYmE5MzA="],"Allergy":["UmVzdHJpY3Rpb246ZTdhNDgxZTAtNWVhNS00NTcwLTg5OWItMzYwYWQzODRjYzhl","UmVzdHJpY3Rpb246MjhlNTY0OGItYTk3ZS00NWNjLWE2ZDEtNmYxZWY2ZjI1YjE0"],"FoodDislikes":["UmVzdHJpY3Rpb246NWE2NjFhYjktZTE2MS00YjU2LTlhOTktZjJhYTExOTEzZWJj"],"Fruit":3,"Veg":3,"Calcium":2,"Grains":3,"FattyFish":2,"IronNeed":0,"SugaryDrinks":3,"Caffeine":3,"Water":9,"Alcohol":6,"SupplementCadence":2,"SupplementType":["calcium","glucosamine","iron","magnesium","melatonin"],"AvoidFormat":["swallowable","chewable","soft-gel","gummy"],"FitnessActivities":["strength-training","yoga"],"FitnessIntensity":2,"ChangeDesire":"nervous"}",
// "surveyData":"[{"contentTypeId":"ms_name","recoId":"Name","recoValues":"Siddhi","values":"Siddhi"},{"contentTypeId":"ms_journey_reasons","recoId":"Reason","recoValues":["my-best-self","feel-great"],"values":["I want to be my best self.","I want to feel good – even great!"]},{"contentTypeId":"ms_interested_wellness_area","recoId":"NeedStateRank","recoValues":["stress-mood","immunity","energy","everyday-health"],"values":["Stress & Mood","Immunity","Energy"]},{"contentTypeId":"ms_health_and_wellness_management","recoId":"WellnessActivities","recoValues":["supplements","meal-replacements"],"values":["Vitamins or supplements","Weight management foods and beverages – like meal replacement shakes"]},{"contentTypeId":"_ms_27_challenge_in_routine","recoId":"WellnessBarriers","recoValues":["knowledge","budget"],"values":["I don't know where to start.","I don't have much money to spend."]},{"contentTypeId":"ms_stress_level","recoId":"StressIntensity","recoValues":"2","values":"I felt a little frazzled here or there."},{"contentTypeId":"ms_key_things_to_stress","recoId":"StressChallenges","recoValues":["work"],"values":["Work"]},{"contentTypeId":"ms_weekly_good_sleep","recoId":"WeeklyGoodSleep","recoValues":"5","values":"4-5 nights"},{"contentTypeId":"ms_fall_asleep","recoId":"FallAsleepTime","recoValues":"30","values":"16-30 minutes."},{"contentTypeId":"ms_night_awakenings","recoId":"SleepQuality","recoValues":"2","values":"Every once in a while."},{"contentTypeId":"ms_feeling_refreshed","recoId":"WakeUpRefreshed","recoValues":"5","values":"Rarely – most days I feel pretty groggy."},{"contentTypeId":"ms_immunity","recoId":"ImmunityPriority","recoValues":"episodic-immunity","values":"Looking for a little extra immune support when I need it most."},{"contentTypeId":"ms_week_energy_level","recoId":"EnergyNeeds","recoValues":"energy-burst","values":"At certain times - like to beat an afternoon slump or for my workout."},{"contentTypeId":"ms_weekly_workout","recoId":"FitnessCadence","recoValues":"0","values":"I don't work out"},{"contentTypeId":"ms_gender_id","recoId":"Gender","recoValues":"Female","values":"Female"},{"contentTypeId":"ms_age_id","recoId":"Age","recoValues":"24","values":"24"},{"contentTypeId":"ms_user_exposure_to_sunlight","recoId":"SunExposure","recoValues":"low","values":"I'm outside less than 20 minutes a day."},{"contentTypeId":"ms_smoke","recoId":"Smoking","recoValues":"0","values":"No"},{"contentTypeId":"ms_foods_and_supplements","recoId":"DietRestrictions","recoValues":["UHJvZ3JhbTowNmFlMGQ4YS03MTE1LTQxYjgtOTlhZi0wZDgzYjVmNTI5MDg=","UHJvZ3JhbTo3YTRhYmYxNi1lZDY3LTQxMDItYTMwYi0wMmJjZjUzMmZkNzc=","UHJvZ3JhbTo1YjQyYTc5Yi0wY2M4LTQyZTYtOGM4Zi05YjIxM2JmYmE5MzA="],"values":["Vegan","Vegetarian","Avoid/Limit Gluten"]},{"contentTypeId":"ms_lifestyle_nutritions","recoId":"Allergy","recoValues":["UmVzdHJpY3Rpb246ZTdhNDgxZTAtNWVhNS00NTcwLTg5OWItMzYwYWQzODRjYzhl","UmVzdHJpY3Rpb246MjhlNTY0OGItYTk3ZS00NWNjLWE2ZDEtNmYxZWY2ZjI1YjE0"],"values":["Curry","Mushrooms"]},{"contentTypeId":"ms_dislikes","recoId":"FoodDislikes","recoValues":["UmVzdHJpY3Rpb246NWE2NjFhYjktZTE2MS00YjU2LTlhOTktZjJhYTExOTEzZWJj"],"values":["Soy"]},{"contentTypeId":"ms_food_habits","recoId":["Fruit","Veg","Calcium","Grains","FattyFish"],"recoValues":["3","3","2","3","2"],"values":["3-4 times per day","3-4 times per day","2 times per day","3-4 times per day","2 times per week"]},{"contentTypeId":"ms_iron_in_diet","recoId":"IronNeed","recoValues":"0","values":"No"},{"contentTypeId":"ms_drink_habits","recoId":["SugaryDrinks","Caffeine","Water","Alcohol"],"recoValues":["3","3","9","6"],"values":["3-4 per day","3-4 per day","9+ per day","3-6 per week"]},{"contentTypeId":"_ms_19_use_of_supplements","recoId":"SupplementCadence","recoValues":"2","values":"I sometimes take supplements."},{"contentTypeId":"ms_supplements","recoId":"SupplementType","recoValues":["calcium","glucosamine","iron","magnesium","melatonin"],"values":["Calcium","Glucosamine","Iron","Magnesium","Melatonin"]},{"contentTypeId":"ms_disliked_supplements","recoId":"AvoidFormat","recoValues":["swallowable","chewable","soft-gel","gummy"],"values":["Swallowable tablets","Chewable tablets","Soft-gel capsules","Gummies"]},{"contentTypeId":"ms_interest_in_exercise","recoId":"FitnessActivities","recoValues":["strength-training","yoga"],"values":["Strength training","Yoga"]},{"contentTypeId":"ms_exercise_routine","recoId":"FitnessIntensity","recoValues":"2","values":"Medium intensity"},{"contentTypeId":"ms_readiness","recoId":"ChangeDesire","recoValues":"nervous","values":"I'm a little nervous, but getting there."}]"}},"query":"query getRecommendation($answers: UserRecoInput) {
//   getRecommendation(answers: $answers) {
//     name
//     recommendations {
//       content
//       products
//       food {
//         avoid
//         eat {
//           foods
//           lookup
//           nsoverlap
//           __typename
//         }
//         __typename
//       }
//       reason
//       __typename
//     }
//     __typename
//   }
// }
// "}
